import { type Language } from "./schemas";

export const languageLabels: Record<string, string> = {
  en: "English",
  ja: "日本語",
};

// Locales where family name precedes given name
const LAST_NAME_FIRST_LOCALES = ["ja", "zh", "ko", "zh-TW", "zh-HK"];

export function isLastNameFirst(locale: string): boolean {
  return LAST_NAME_FIRST_LOCALES.includes(locale);
}

export function formatPersonName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  locale: string,
): string {
  const parts = isLastNameFirst(locale)
    ? [lastName, firstName]
    : [firstName, lastName];
  return parts.filter(Boolean).join(" ");
}

export function resolveLanguage(
  organization: { language: string },
  project?: { language: string | null },
): Language {
  return (project?.language ?? organization.language) as Language;
}

export function formatName(
  language: Language,
  user: { givenName: string; familyName: string },
) {
  return isLastNameFirst(language)
    ? `${user.familyName} ${user.givenName}`
    : `${user.givenName} ${user.familyName}`;
}
